import { Link } from 'react-router-dom';
import { Star, ArrowRight, ArrowUpRight } from 'lucide-react';
import { Chapter, FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';
import { GOOGLE_PROFILE_URL } from '../../data/content';

export default function Reviews() {
  const t = useT();
  const { REVIEWS, TICKER } = useContent();

  return (
    <section data-testid="reviews-section" className="bg-white py-24 text-ink md:py-32">
      <div className="container-site">
        <Chapter n={7} label={t['ch.reviews']} dark />
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <FadeUp>
            <h2 className="max-w-xl font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
              {t['rv.h2a']} <span className="italic text-gold-dim">{t['rv.h2b']}</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.1}>
            <a data-testid="google-rating-summary" href={GOOGLE_PROFILE_URL} target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-4 rounded-xl border border-black/10 bg-neutral-50 px-6 py-4 transition-shadow hover:shadow-lg">
              <span className="font-serif text-5xl font-semibold">4.9</span>
              <div>
                <span className="flex text-gold">{[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-gold" />)}</span>
                <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-neutral-500">
                  20+ {t['rv.googleReviews']} <ArrowUpRight className="h-3 w-3" />
                </p>
              </div>
            </a>
          </FadeUp>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <FadeUp key={r.name} delay={(i % 3) * 0.08} className="h-full">
              <figure data-testid={`review-${i}`} className="flex h-full flex-col rounded-xl border border-black/10 bg-white p-7 shadow-sm transition-shadow duration-500 hover:shadow-xl">
                <span className="flex text-gold">{[...Array(r.rating)].map((_, j) => <Star key={j} className="h-4 w-4 fill-gold" />)}</span>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-neutral-600">"{r.text}"</blockquote>
                <figcaption className="mt-5 border-t border-black/5 pt-4">
                  <p className="text-sm font-bold">{r.name}</p>
                  <p className="text-xs text-neutral-500">{r.area} · {r.service}</p>
                </figcaption>
              </figure>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.1} className="mt-10 flex flex-wrap items-center gap-5">
          <Link data-testid="reviews-quote-cta" to="/quote" className="gold-btn">
            {t['rv.cta']} <ArrowRight className="h-4 w-4" />
          </Link>
          <a data-testid="reviews-google-link" href={GOOGLE_PROFILE_URL} target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-sm font-bold text-gold-dim transition-colors hover:text-gold">
            {t['rv.readOnGoogle']} <ArrowUpRight className="h-4 w-4" />
          </a>
        </FadeUp>
      </div>

      <div data-testid="jobs-ticker" className="mt-16 overflow-hidden border-y border-black/10 bg-neutral-50 py-4">
        <div className="marquee-track" style={{ animationDuration: '60s' }}>
          {[0, 1].map((dup) => (
            <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
              {TICKER.map((item, i) => (
                <span key={i} className="flex items-center whitespace-nowrap text-sm font-semibold text-neutral-500">
                  <span className="mx-6 inline-block h-1.5 w-1.5 rounded-full bg-gold" />
                  {item}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
